export default __webpack_public_path__ + "static/thumbnail_multiple_updated-317e585c34b3a64b94a05b8dd39dc910.png";